import { NgModule } from '@angular/core';
import { MatSelectModule } from '@angular/material/select';
import { SelectWithSearchModule } from '@core/components/select-with-search/select-with-search.module';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { SegmentsComponent } from './segments.component';

@NgModule({
  entryComponents: [
    SegmentsComponent
  ],
  declarations: [
    SegmentsComponent
  ],
  imports: [
    TranslateModule,
    FuseSharedModule,

    MatSelectModule,
    SelectWithSearchModule
  ],
  exports: [
    SegmentsComponent
  ]
})
export class SegmentsModule { }
